module.exports = __webpack_public_path__ + "static/img/装饰12.6d820ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰12.svg
// module id = Kqwu
// module chunks = 2